import React from 'react'
import { ModalTitle } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';


const Modalb = (props) => {
  const { Title = "", children, show, size } = props;
  return (
    <Modal
      show={show}
      size={size}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <ModalTitle>
          <div className="modals-header">
            <h2>{Title}</h2>
          </div>
        </ModalTitle>
        <svg style={{cursor: "pointer"}} onClick={props.onHide} width={25} height={25} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M17.9175 0C22.1537 0 25 2.9725 25 7.395V17.605C25 22.0275 22.1537 25 17.9163 25H7.08125C2.845 25 0 22.0275 0 17.605V7.395C0 2.9725 2.845 0 7.08125 0H17.9175ZM17.9175 1.875H7.08125C3.91875 1.875 1.875 4.04125 1.875 7.395V17.605C1.875 20.9587 3.91875 23.125 7.08125 23.125H17.9163C21.08 23.125 23.125 20.9587 23.125 17.605V7.395C23.125 4.04125 21.08 1.875 17.9175 1.875ZM10.1631 8.82825L12.4975 11.1625L14.8306 8.83088C15.1969 8.46463 15.7894 8.46463 16.1556 8.83088C16.5219 9.19713 16.5219 9.78962 16.1556 10.1559L13.8225 12.4875L16.1581 14.8245C16.5244 15.1908 16.5244 15.7832 16.1581 16.1495C15.9756 16.3333 15.7344 16.4245 15.4956 16.4245C15.2556 16.4245 15.0156 16.3333 14.8331 16.1495L12.4975 13.8125L10.1656 16.1459C9.98312 16.3296 9.74312 16.4209 9.50313 16.4209C9.26313 16.4209 9.02313 16.3296 8.84063 16.1459C8.47438 15.7796 8.47438 15.1871 8.84063 14.8209L11.1725 12.4875L8.83813 10.1532C8.47188 9.787 8.47188 9.1945 8.83813 8.82825C9.20562 8.462 9.79813 8.462 10.1631 8.82825Z" fill="black" />
        </svg>
      </Modal.Header>
      <Modal.Body className='p-0'>
        {children}
      </Modal.Body>
    </Modal>
  )
}

export default Modalb